import { fetchApi } from '@/services/api-client';

export type SupportNoteVisibility = 'staff' | 'sst_only';

export type SupportNote = {
  id: string;
  studentId: string;
  body: string;
  visibility: SupportNoteVisibility;
  authorId: string | null;
  authorName: string | null;
  createdAt: string;
  updatedAt: string;
};

export type SharedSupportNotes = { studentId: string; notes: SupportNote[] };

export type SupportNoteData = { body: string; visibility: SupportNoteVisibility };

const path = (studentId: string) => `/students/${studentId}/support-notes`;

export const supportNotesApi = {
  list: (studentId: string) => fetchApi<SupportNote[]>(path(studentId)),
  shared: () => fetchApi<SharedSupportNotes[]>('/support-notes/shared'),
  create: (studentId: string, data: SupportNoteData) =>
    fetchApi<SupportNote>(path(studentId), { method: 'POST', body: JSON.stringify(data) }),
  update: (studentId: string, noteId: string, data: Partial<SupportNoteData>) =>
    fetchApi<SupportNote>(`${path(studentId)}/${noteId}`, { method: 'PATCH', body: JSON.stringify(data) }),
  remove: (studentId: string, noteId: string) =>
    fetchApi<{ ok: true }>(`${path(studentId)}/${noteId}`, { method: 'DELETE' }),
};
